/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateBaseCustomerCommand } from './CreateBaseCustomerCommand';
import type { SaveAddressCommand } from './SaveAddressCommand';
import type { SaveNameCommand } from './SaveNameCommand';
export type CreateCustomerCommand = {
    name: SaveNameCommand;
    /**
     * Customer birthday. Type: 'DATE'
     */
    birthDay: string;
    email?: string;
    phoneNumber?: string;
    address: SaveAddressCommand;
    /**
     * Base64 representation of picture.
     */
    photo?: string;
    /**
     * Card type
     */
    cardType?: CreateCustomerCommand.cardType;
    originId?: string;
    /**
     * Custodian identifier. Type: "UUID"
     */
    parentId?: string;
    /**
     * Custodian object.
     */
    parent?: CreateBaseCustomerCommand;
    /**
     * GDPR, terms and conditions approval.
     */
    gdprTermsApproval?: boolean;
    /**
     * PIN for card blockage after loss.
     */
    pin?: string;
    isicNumber?: string;
    /**
     * Type for customer account link. Need to know when age restriction for ASSIGNED type is disabled
     */
    accountLinkType?: CreateCustomerCommand.accountLinkType;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
};
export namespace CreateCustomerCommand {
    /**
     * Card type
     */
    export enum cardType {
        SMART_CARD = 'SMART_CARD',
        SMART_CARD_2 = 'SMART_CARD_2',
        SMART_CARD_WITHOUT_STRUCTURE = 'SMART_CARD_WITHOUT_STRUCTURE',
        BANK_CARD = 'BANK_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
        WHITE_LIST_CARD = 'WHITE_LIST_CARD',
        EXTERNAL_CARD = 'EXTERNAL_CARD',
        QR_CODE_CARD = 'QR_CODE_CARD',
        PAPER_CARD = 'PAPER_CARD',
    }
    /**
     * Type for customer account link. Need to know when age restriction for ASSIGNED type is disabled
     */
    export enum accountLinkType {
        REGISTERED = 'REGISTERED',
        ASSIGNED = 'ASSIGNED',
        MANAGED = 'MANAGED',
    }
}

